import { Controller, useFormContext } from "react-hook-form";
import { SetupNative2faFormValues } from "../../types";
import { View } from "react-native-ui-lib";
import { MfaMethodOptions } from "../MfaMethodOptions";

export interface SelectMfaMethodFieldsetProps {
  onComplete?: () => void;
}

export const SelectMfaMethodFieldset = (
  props: SelectMfaMethodFieldsetProps
) => {
  const { control, watch } = useFormContext<SetupNative2faFormValues>();
  const strategies = watch("ui.strategies");
  return (
    <View>
      <Controller
        control={control}
        name="data.strategy"
        render={({ field: { onChange, value } }) => {
          function handleChange(...event: any[]) {
            onChange(...event);
            props.onComplete && props.onComplete();
          }

          return (
            <MfaMethodOptions
              onChange={handleChange}
              value={value}
              strategies={(strategies || []) as any}
            />
          );
        }}
      />
    </View>
  );
};
